/**
 * Created on 2018/07/10.
 */
define('services/mysetting/tenants.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('tenantsService', ['$q', 'ngDialog', '$filter', '$state', '$rootScope', 'OpenUp', 'UserInfo',
        function ($q, ngDialog, $filter, $state, $rootScope, OpenUp, UserInfo) {
            //商户常量配置
            var merchantCfg = mainCons.modUserinfoConstant;
            //离岸错误消息
            var errorMsg = merchantCfg.errorMsg;
            /**
             * 商户认证状态校验，任意一种银行卡通过,则商户认证状态通过，ture：通过
             */
            function isBankVoid() {
                var queryRangeFlag = '1';
                var defer = $q.defer();
                //判断银行卡信息审核是否通过，银行卡、税务、联系人完整性
                OpenUp.getMerchantInfo({
                    req: {
                        bankType: 2,
                        queryRangeFlag: queryRangeFlag
                    }
                }).then(function (data) {
                    var verifyBankState = false;
                    if (data && data.developerBanks && data.developerBanks.length > 0) {
                        for (var i = 0; i < data.developerBanks.length; i++) {
                            var developerBank = data.developerBanks[i];
                            //未银行信息(或草稿状态)；  1 首次银行信息待审核     2 首次银行信息审核通过3 首次银行信息审核未通过（再次提交银行信息资料修改，后台自动变更为1）
                            //校验银行状态是审核通过且银行帐号信息完整
                            if (developerBank.bankType == 0 || developerBank.bankType == 1) {
                                verifyBankState = verifyBankState || (developerBank.verifyBankState == 2 && developerBank.bankAccount)
                            }
                        }
                        //校验税务和联系人完整性,不校验,后台保证完整性res && res.contactInfo && res.userTaxInfo && res.userTaxInfo.taxReceiptType
                    }
                    defer.resolve(verifyBankState)
                }, function () {
                    defer.resolve(false);
                }).catch(function () {
                    defer.resolve(false);
                });
                return defer.promise;
            }

            //获取指定国家的银行配置
            function getBankRuleByCountry(country, merchantCfg) {
                var defer = $q.defer();
                if (!country || typeof merchantCfg != 'object') {
                    defer.reject();
                }
                //优先取后台校验规则
                OpenUp.getBankRuleNew({req: {countryAlpha2Code: country}}).then(function (rs) {
                    if (rs.resultCode == '0' && rs.bankRuleList) {
                        merchantCfg.countryBankCfg = transform(rs.bankRuleList, country, merchantCfg);
                    }
                    defer.resolve(merchantCfg);
                }, function () {
                    defer.reject();
                });
                return defer.promise;
            }

            //以下依赖常量country-bank.constant.js配置中配置
            function transform(bankRules, country, merchantCfg) {
                var fields = merchantCfg.fields;
                var errorMsg = merchantCfg.errorMsg;
                var fieldTips = merchantCfg.tips;
                var tempObj = {};
                tempObj[country] = {};
                bankRules.forEach(function (item) {
                    //默认type=S
                    tempObj[country][item.attrName] = {
                        showFlag: true,
                        placeholder: '',
                        tips: '',
                        backRegExp: item.backRegExp,
                        bankField: item.attrName, //对应的$scope.bankInfo的属性名
                        fieldName: '',//国际化显示的名称
                        required: item.require == 'T',
                        attrType: item.attrType,
                        value: item.value,
                        //false不禁用，true禁用,不是通用字段，只有几个字段使用
                        disabled: true
                    };
                    //特殊名称的转换
                    (item.attrName == 'city') && (tempObj[country][item.attrName].bankField = 'hCity');
                    (item.attrName == 'accountNumber') && (tempObj[country][item.attrName].bankField = 'bankAccount');
                    (item.attrName == 'accountName') && (tempObj[country][item.attrName].bankField = 'bankAcctName');
                    //accountType特殊处理
                    if(item.attrName == 'accountType' && item.value) {
                        var arr = item.value.split(',');
                        tempObj[country][item.attrName].value = arr;
                    } else if (item.attrName == 'accountType') {
                        tempObj[country][item.attrName].value = merchantCfg.accountTypes;
                    }
                    //这个变量attribute4和type=E逻辑都需要
                    /* 各个国家的attribute4设置 保证key和值不等*/
                    //attribute4特殊处理,显示的字段不同,在en.json中必然存在，不存在需求有问题
                    (item.attrName == 'attribute4') && (tempObj[country].attribute4.fieldName = fields[country + '_attribute4']);

                    //动态验证表达式
                    if (item.frontRegExp) {
                        (item.attrName == 'iban' && item.frontRegExp) && (item.frontRegExp = item.frontRegExp.slice(0, 1) + country + item.frontRegExp.slice(1));
                        tempObj[country][item.attrName].pattern = item.frontRegExp = item.frontRegExp;
                    }
                    //判断提示字符还是数字
                    var placeHoldSubfix = '个字符';
                    //判断是否含有字符,一般都含有A-Z或者a-z
                    var pattern = tempObj[country][item.attrName].pattern;
                    if (pattern && (pattern.indexOf('a') == -1 && pattern.indexOf('A') == -1 || pattern.indexOf('z') == -1 && pattern.indexOf('Z') == -1)) {
                        placeHoldSubfix = '位数字';
                    }
                    var ranges = item.length && item.length.split('-');
                    //默认字段占位符
                    var placeStr = '';
                    if (ranges && ranges.length > 1) {
                        //iban特殊处理
                        item.attrName == 'iban' && (ranges = ranges.map(function (v, idx, arr) {
                            return parseInt(v) - 2 > 1 ? parseInt(v) - 2 : 1;
                        }));
                        tempObj[country][item.attrName]['isLenEnum'] = false;
                        tempObj[country][item.attrName]['maxLength'] = ranges[1];
                        tempObj[country][item.attrName]['minLength'] = ranges[0];

                        if(item.attrName == 'iban'){
                            placeStr = country + "后跟" + (ranges[0]>1?ranges[0]-2:ranges[0]) + '-' + (ranges[1]-2) + placeHoldSubfix;
                        }else{
                            placeStr = ranges[0] + '-' + ranges[1] + ' ' + placeHoldSubfix;
                        }

                        tempObj[country][item.attrName]['placeholder'] = placeStr;
                    } else if (ranges) {
                        //目前只支持2位比如说8位或11位swiftCode
                        var lenEnums = item.length.split(',');
                        tempObj[country][item.attrName]['isLenEnum'] = true;
                        tempObj[country][item.attrName]['lengthEnum'] = lenEnums;
                        //几位字符的表达式
                        var fixLenReg = [];
                        if (lenEnums.length > 1) {
                            var placeHolds = [];
                            lenEnums.forEach(function (k, idx, arr) {
                                placeHolds.push(k-2);
                                fixLenReg.push('^[a-zA-Z0-9]{' + k + '}$');
                            });
                            if(item.attrName == 'iban'){
                                placeStr = country + "后跟" + placeHolds.join(' 或者 ') + placeHoldSubfix;
                            }else{
                                placeStr = placeHolds.join(' 或者 ') + ' ' + placeHoldSubfix;
                            }

                            var fixLenParttern = fixLenReg.join('|');
                            lenEnums.sort(function (a, b) {
                                return a - b;
                            });
                            tempObj[country][item.attrName]['maxLength'] = lenEnums[lenEnums.length - 1];
                            tempObj[country][item.attrName]['minLength'] = lenEnums[0];
                            //如果没有则采用自定义的验证规则
                            !tempObj[country][item.attrName].pattern && (tempObj[country][item.attrName].pattern = fixLenParttern);
                        } else {
                            tempObj[country][item.attrName]['maxLength'] = lenEnums[0];
                            tempObj[country][item.attrName]['minLength'] = lenEnums[0];
                            if(item.attrName == 'iban'){
                                placeStr = country + "后跟" + (lenEnums[0]-2) + placeHoldSubfix;
                            }else{
                                placeStr = lenEnums[0] + ' ' + placeHoldSubfix;
                            }

                        }
                        tempObj[country][item.attrName]['placeholder'] = placeStr;
                    }
                    //占位信息获取
                    errorMsg[country + '_' + item.attrName] && (tempObj[country][item.attrName].error = errorMsg[country + '_' + item.attrName]);
                    //如果只有错误，却没有提示，也显示问题提示，内容是错误提示
                    (fieldTips[country + '_' + item.attrName] || errorMsg[country + '_' + item.attrName]) && (tempObj[country][item.attrName].tips = (fieldTips[country + '_' + item.attrName] ? fieldTips[country + '_' + item.attrName] : '') + (tempObj[country][item.attrName].error ? tempObj[country][item.attrName].error : ''));
                    //中国 伊朗除外 4.0.5.102
                });
                //不存在重置成空对象,因为老代码后期使用，减少改动老代码
                function resetNull2Obj() {
                    var fields = ['bankName', 'bankNumber', 'branchName', 'branchNumber', 'city', 'branchAddress', 'attribute4', 'swiftCode', 'accountName', 'iban', 'accountNumber', 'currency', 'accountType', 'kc', 'taxPayerID'];
                    fields.forEach(function (v, idx, arr) {
                        !tempObj[country][v] && (tempObj[country][v] = {});
                    });
                }
                resetNull2Obj();
                return tempObj;
            }

            //校验单个字段
            function validateField(bank, item) {
                //如果没有值或者规则，返回失败
                if (!bank || !item) {
                    return false
                }
                function converReg(bank, backReg) {
                    var rs = backReg;
                    rs = rs.replace(/#country#/g, (typeof bank.country == 'object' ? bank.country.key : bank.country));
                    rs = rs.replace(/#bankNumber#/g, bank.bankNumber);
                    rs = rs.replace(/#branchNumber#/g, bank.branchNumber);
                    rs = rs.replace(/#IBAN#/g, bank.iban);
                    rs = rs.replace(/#accountNumber#/g, bank.bankAccount);
                    return rs;
                }
                var value = bank[item.bankField];
                (item.bankField == 'bankName') && (value = bank.bank.value);
                (item.bankField == 'branchName') && (value = bank.branch.value);
                (item.bankField == 'iban') && (value = bank.iban);
                //正则校验
                var passed = new RegExp(converReg(bank, item.backRegExp)).test(value);
                return passed;
            }

            //在提交之前进行验证
            function checkByServerCfg(bank, cfg) {
                //默认通过
                var passed = true;
                //没数据不校验
                if(!bank || !cfg){
                    return passed;
                }
                for (var key in cfg) {
                    //缩小范围，保证可以提交,保证有提示的时候才校验，否则不校验
                    var item = cfg[key];
                    var country = typeof bank.country == 'object' ? bank.country.key : bank.country;
                    if (item && item.backRegExp && errorMsg[country + '_' + key]) {
                        passed = validateField(bank, item);
                        //校验不通过跳出
                        if (!passed) {
                            item.showError = true;
                            var el = angular.element("[name='" + item.bankField + "EN" + "']");
                            if (!el.length) {
                                el = angular.element("[name='" + item.bankField + "']");
                            }
                            item.bankField && el.length && (el.focus());
                            break;
                        }
                    }
                }
                return passed;
            }

            //判断一个元素是否在数组中
            function isInArray(arr, prop, value) {
                if (!arr) {
                    return false;
                }
                for (var i = 0; i < arr.length; i++) {
                    if (value === arr[i][prop]) {
                        return true;
                    }
                }
                return false;
            }

            function getInArray(arr, prop, value) {
                if (!arr) {
                    return null;
                }
                for (var i = 0; i < arr.length; i++) {
                    if (value === arr[i][prop]) {
                        return arr[i];
                    }
                }
                return null;
            }

            //离岸银行转换支行号信息
            function convertBranchs(curBranchs,branchs) {
                var branchsRs = [];
                for (var i = 0; branchs && i < branchs.length; i++) {
                    if (!isInArray(curBranchs, 'branchName', branchs[i].branchName)) branchsRs.push({
                        key: branchs[i].branchName,
                        value: branchs[i].branchName,
                        bankNumber: branchs[i].bankNumber,
                        branchNumber: branchs[i].branchNumber,
                        swiftCode: branchs[i].swiftCode,
                        hCity: branchs[i].city,
                        branchAddress: branchs[i].address1,
                        kc:branchs[i].kc
                    });
                }
                return branchsRs;
            }
            function setPageContactInfo(Model,contactList) {
                Model.merchantContacts = [];
                Model.contactInfoList = contactList;
                var marketTemp = false;
                var financeTemp = false;
                var legalTemp = false;
                var coorperationTemp = false;
                if (Model.contactInfoList) {
                    Model.contactInfoList.forEach(function (v) {
                        Model.merchantContacts.push({
                            'key': v.contactID,
                            'value': v.familyName + ' ' + v.givenName
                        });
                        if (Model.contactorInfo.market && v.contactID == Model.contactorInfo.market.key) {
                            marketTemp = true;
                            Model.contactorInfo.market.value = v.familyName + ' ' + v.givenName;
                        }
                        if (Model.contactorInfo.finance && v.contactID == Model.contactorInfo.finance.key) {
                            financeTemp = true;
                            Model.contactorInfo.finance.value = v.familyName + ' ' + v.givenName;
                        }
                        if (Model.contactorInfo.legal && v.contactID == Model.contactorInfo.legal.key) {
                            legalTemp = true;
                            Model.contactorInfo.legal.value = v.familyName + ' ' + v.givenName;
                        }
                        if (Model.contactorInfo.coorperation && v.contactID == Model.contactorInfo.coorperation.key) {
                            coorperationTemp = true;
                            Model.contactorInfo.coorperation.value = v.familyName + ' ' + v.givenName;
                        }
                    });
                    if (!marketTemp) {
                        Model.contactorInfo.market = null;
                    }
                    if (!financeTemp) {
                        Model.contactorInfo.finance = null;
                    }
                    if (!legalTemp) {
                        Model.contactorInfo.legal = null;
                    }
                    if (!coorperationTemp) {
                        Model.contactorInfo.coorperation = null;
                    }
                } else {
                    Model.merchantContacts = [];
                    Model.contactorInfo = {};
                }

            }

            return {
                'isBankVoid': isBankVoid,
                'getBankRuleByCountry': getBankRuleByCountry,
                'checkByServerCfg': checkByServerCfg,
                'validateField': validateField,
                'convertBranchs': convertBranchs,
                'isInArray': isInArray,
                'getInArray': getInArray,
                'setPageContactInfo':setPageContactInfo
            }
        }]);
});


